var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStorage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99423 6.66288C14.134 6.66288 17.4899 5.54424 17.4899 4.16432C17.4899 2.78441 14.134 1.66577 9.99423 1.66577C5.85449 1.66577 2.49857 2.78441 2.49857 4.16432C2.49857 5.54424 5.85449 6.66288 9.99423 6.66288Z",
    stroke: "#1A1D2E",
    strokeWidth: 1.6657,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49857 4.16431V15.8242C2.49857 16.4869 3.28828 17.1224 4.69399 17.591C6.0997 18.0595 8.00625 18.3228 9.99423 18.3228C11.9822 18.3228 13.8887 18.0595 15.2945 17.591C16.7002 17.1224 17.4899 16.4869 17.4899 15.8242V4.16431",
    stroke: "#1A1D2E",
    strokeWidth: 1.6657,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49857 9.99414C2.49857 10.6568 3.28828 11.2923 4.69399 11.7609C6.0997 12.2295 8.00625 12.4927 9.99423 12.4927C11.9822 12.4927 13.8887 12.2295 15.2945 11.7609C16.7002 11.2923 17.4899 10.6568 17.4899 9.99414",
    stroke: "#1A1D2E",
    strokeWidth: 1.6657,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorage);
export default __webpack_public_path__ + "static/media/storage.16540b5bc6dcc071aad223fd48195463.svg";
export { ForwardRef as ReactComponent };